

import React, { useEffect, useState } from "react";
import { trackPromise } from 'react-promise-tracker';
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { Box, Grid } from "@material-ui/core/";
import DnerhsApi, { CancelToken } from "../../../../api/DnerhsApi";
import Alert from "../../../../components/Alert";
import ResponseUtils from "../../../../utils/ResponseUtils";
import useAuth from "../../../../hooks/Auth";
import $ from "jquery";
import 'datatables.net-dt/css/dataTables.dataTables.min.css'; // DataTables estilos
import "datatables.net"; // DataTables script
import 'datatables.net-buttons-dt/css/buttons.dataTables.min.css'; // Estilos para los botones
import "datatables.net-buttons/js/dataTables.buttons.min.js"; // Script de botones
import "datatables.net-buttons/js/buttons.html5.min.js"; // Exportación HTML5 (Excel, CSV, etc.)
import "datatables.net-buttons/js/buttons.print.min.js"; // Exportación para impresión
import jszip from "jszip"; // Para exportación a Excel
import pdfmake from "pdfmake"; // Para exportación a PDF
// import 'Styles/PracticasConvenioList.css'; // Importa el CSS

// Asegúrate de que `jszip` y `pdfmake` estén globalmente disponibles
window.JSZip = jszip;
window.pdfMake = pdfmake;

const PracticasConvenioList = () => {
  const [rows, setRows] = useState([]);
  const { hasRole } = useAuth();
  const [establecimientoId, setEstablecimientoId] = useState();

// icono SVG de verificación fino
const checkIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="green" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12" /></svg>`;

//  icono SVG de cierre fino
const closeIconSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="red" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>`;

  useEffect(() => {
    loadData(); // Cargar datos inicialmente
  }, []);

  const getEstablecimiento = async () => {
      const { data } = await trackPromise(DnerhsApi.get("/instituciones/establecimientos/responsables/info"));
      return data;
    }
  
  const loadData = async () => {
    const source = CancelToken.source();
    try {
      let establecimiento = await getEstablecimiento();

      setEstablecimientoId(establecimiento.id);

      const url = `/practicas-convenio/${establecimiento.id}/practicas-establecimiento`
      console.log("Cargando datos desde la URL:", url);
      const response = await DnerhsApi.get(url, {
        cancelToken: source.token,
      });

      if (response.status === 200) {
        const rowsData = response.data;
        setRows(rowsData || []); // Asegurarse de que rowsData no sea undefined
      } else {
        console.error("Error al obtener datos de la API.");
      }
    } catch (error) {
      console.log(error);
      showServerError(error);
    }
  };

  const showServerError = (error) => {
    let message = "Ocurrió un error inesperado, por favor vuelva a reintentar";
    if (error.response) {
      message = ResponseUtils.getMessageError(error.response);
    }

    Alert.show({
      message,
      type: "error",
    });
  };

 // Configurar DataTable cuando los datos cambian
 useEffect(() => {
  if (rows.length) {
    const table = $('#dataTable').DataTable({
      data: rows,
      columns: [
        { title: "Estudiante", data: "nombreApellido", width: '250px' }, // Aumentado a 300px
        { title: "C.I.", data: "cedulaIdentidad" },
        { title: "Año", data: "anio" },
        { title: "Semestre", data: "semestre" },
        { 
          title: "D",
          data: "domingo",
          render: function(data, type) {
            if (type === 'display') {
              return data
                ? `<span title="${data}" style="cursor: help; font-size: 2.0em;">${checkIconSVG}</span>`
                : `<span title="Sin Dato" style="cursor: help; font-size: 2.0em;">${closeIconSVG}</span>`;
            }
            return data ? "Sí" : "No";
          }
        },
         
      
        { 
          title: "L",
          data: "lunes",
          render: function(data, type) {
            if (type === 'display') {
              return data
                ? `<span title="${data}" style="cursor: help; font-size: 2.0em;">${checkIconSVG}</span>`
                : `<span title="Sin Dato" style="cursor: help; font-size: 2.0em;">${closeIconSVG}</span>`;
            }
            return data ? "Sí" : "No";
          }
        },
         
        { 
          title: "M", 
          data: "martes",
          render: function(data, type) {
            if (type === 'display') {
              return data
                ? `<span title="${data}" style="cursor: help; font-size: 2.0em;">${checkIconSVG}</span>`
                : `<span title="Sin Dato" style="cursor: help; font-size: 2.0em;">${closeIconSVG}</span>`;
            }
            return data ? "Sí" : "No";
          }
        },
         
        { 
          title: "X", 
          data: "miercoles",
          render: function(data, type) {
            if (type === 'display') {
              return data
                ? `<span title="${data}" style="cursor: help; font-size: 2.0em;">${checkIconSVG}</span>`
                : `<span title="Sin Dato" style="cursor: help; font-size: 2.0em;">${closeIconSVG}</span>`;
            }
            return data ? "Sí" : "No";
          }
        },
         
        { 
          title: "J", 
          data: "jueves",
          render: function(data, type) {
            if (type === 'display') {
              return data
                ? `<span title="${data}" style="cursor: help; font-size: 2.0em;">${checkIconSVG}</span>`
                : `<span title="Sin Dato" style="cursor: help; font-size: 2.0em;">${closeIconSVG}</span>`;
            }
            return data ? "Sí" : "No";
          }
        },
         
        { 
          title: "V", 
          data: "viernes",
          render: function(data, type) {
            if (type === 'display') {
              return data
                ? `<span title="${data}" style="cursor: help; font-size: 2.0em;">${checkIconSVG}</span>`
                : `<span title="Sin Dato" style="cursor: help; font-size: 2.0em;">${closeIconSVG}</span>`;
            }
            return data ? "Sí" : "No";
          }
        },
         
        { 
          title: "S", 
          data: "sabado",
          render: function(data, type) {
            if (type === 'display') {
              return data
                ? `<span title="${data}" style="cursor: help; font-size: 2.0em;">${checkIconSVG}</span>`
                : `<span title="Sin Dato" style="cursor: help; font-size: 2.0em;">${closeIconSVG}</span>`;
            }
            return data ? "Sí" : "No";
          }
        },
         
        { title: "Total Horas", data: "totalHoras" },
        { title: "Ci Tutor", data: "ciTutor" },
        { title: "Tutor", data: "tutor", width: '300px' }, // Aumentado a 300px
        { title: "Institución", data: "institucion", width: '300px' }, // Aumentado a 300px
        { title: "Carrera", data: "carrera", width: '250px' }, // Aumentado a 250px
        { title: "Materia", data: "materia", width: '300px' }, // Aumentado a 300px
        { title: "Fecha Desde", data: "fechaDesde" },
        { title: "Fecha Hasta", data: "fechaHasta" }
      ],
      destroy: true,
      autoWidth: false,
      responsive: true,
      lengthMenu: [10, 20, 50, 100],
      buttons: [
        {
          extend: 'excelHtml5',
          exportOptions: {
            rows: { search: 'applied' }, // Asegura que exporte todas las filas filtradas
            columns: ':visible',
            format: {
              body: function(data, row, column, node) {
                if (column >= 4 && column <= 10) { // Columnas de días de la semana
                  let table = $('#dataTable').DataTable();
                  let cellData = table.cell(row, column).data(); // Obtiene el dato real de la celda
                  return cellData === null ? 'No' : cellData;
                }
                return data;
              }
            }
          }
        },
        {
          extend: 'copyHtml5',
          exportOptions: {
            rows: { search: 'applied' }, // Asegura que exporte todas las filas filtradas
            columns: ':visible',
            format: {
              body: function(data, row, column, node) {
                if (column >= 4 && column <= 10) { // Columnas de días de la semana
                  let table = $('#dataTable').DataTable();
                  let cellData = table.cell(row, column).data(); // Obtiene el dato real de la celda
                  return cellData === null ? 'No' : cellData;
                }
                return data;
              }
            }
          }
        }
      ],
      
      
      dom: '<"top"<"pull-right"f>rt<"bottom"Blpi><"clear">',
      language: {
        url: "/assets/es.json"
      },
      scrollX: true,
      fixedHeader: true
    });

    return () => {
      table.destroy();
    };
  }
}, [rows]);

return (
  <Grid container spacing={4}>
    <Grid item xs={12}>
      <Paper>
        <Box p={2}>
          <Typography variant="h5" color="primary" align="center">
          Cronograma de Prácticas
          </Typography>
          {rows.length > 0 ? (
            <div style={{ overflowX: 'auto', width: '100%' }}> {/* Hacer que la tabla ocupe todo el ancho */}
              <table 
                id="dataTable" 
                style={{ width: '100%', borderCollapse: 'collapse' }} 
                className="display"
              >
                <thead>
                  <tr>
                
                    <th>Nombre y Apellido</th>
                    <th>Cédula de Identidad</th>
                    <th>Año</th>
                    <th>Semestre</th>
                    <th>D</th>
                    <th>L</th>
                    <th>M</th>
                    <th>X</th>
                    <th>J</th>
                    <th>V</th>
                    <th>S</th>
                    <th>Total Horas</th>
                    <th>Ci.Tutor</th>
                    <th>Tutor</th>
                    <th>Institución</th>
                    <th>Carrera</th>
                    <th>Materia</th>
                    <th>Fecha Desde</th>
                    <th>Fecha Hasta</th>
                  </tr>
                </thead>
              </table>
            </div>
          ) : (
            <Typography align="center" color="textSecondary">
              No se encontraron resultados
            </Typography>
          )}
        </Box>
      </Paper>
    </Grid>
  </Grid>
);
};


export default PracticasConvenioList;
